// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"abf7a398","239":"5d64bb7a","453":"8236e8af","667":"773b0b2a"}[chunkId] + ".chunk.js";
};